<div class="row_1">
    <div>
        <label class="label tab-heading " *ngIf="isAccessible" (click)="openRouteLevel('contingency-pcs')">
            Contingency PCS</label>
        <label class="label tab-heading titlered">Contingency Master Tables</label>

        <button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue();">Add To
            Queue</button>
    </div>
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
        <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="refreshDataPCS()">
        <app-periods-dropdown periodLabel="Period" (eventHandler)="componentEventHandler($event);">
        </app-periods-dropdown>
        <label class="drpdwn_period_label" style="margin-left:2%"> Contingency Date</label>
        <input type="date" onkeypress="return false" class="drpdwn_period" [(ngModel)]="selectContingencyDate"
            (change)="dateChange();">
        <label class="drpdwn_period_label" style="margin-left:0.4%"> Doubleship Date</label>
        <input type="date" onkeypress="return false" class="drpdwn_period" [(ngModel)]="selectDoubleShipDate"
            (change)="dateChange();">
        <button class="primarybutton" (click)="addDatesToPCS();">ADD</button>
        <button class="primarybutton" style="float: right;margin-top: 0.7%;" (click)="uploadData();">
            <img src="./assets/images/file_upload.svg" style="margin-right: 4px;">
            UPLOAD
        </button>
        <img src="./assets/images/vertical_line.svg" class="line">
        <div class="grid-agg" style="padding-bottom: 1%;">
            <hr style="margin:0;padding-top: 0.6%; visibility: hidden;">
            <div class="row">
                <div class="col-6" style="padding:0 0.8% 0 1.2%">
                    <label class="gridcaption">PCS Data Table</label>
                    <ag-grid-angular #ContPCSGrid style="width:100%;height: 375px;" id="LIOS-GRID" [theme]="'legacy'"
                        class="ag-theme-balham" (gridReady)="PCS_onGridReady($event);" (window:resize)="PCS_sizeToFit()"
                        [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="PCS_columnDefs"
                        [rowData]="PCS_displayRowData"   [context]="PCS_context"
                        [pagination]="true" [paginationPageSize]="PCS_rowCount" [icons]="icons" [gridOptions]="gridOptions">
                    </ag-grid-angular>
                    <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                        <div class="w-25 col-4 ">
                            <div>
                                <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                                <select class="page-drpdwn" (change)="onPCSPageSizeChanged($event)">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="ALL" selected>ALL</option>
                                </select>
                            </div>
                        </div>

                        <div style="display: flex;" class="pagination_text col-4 offset-2">

                            <!-- first -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPagePCS()"
                                [ngClass]="{'disable_icon':getCurrentPagePCS()== true,'enable_icon':getCurrentPagePCS()!= true}">
                                first_page</mat-icon>

                            <!-- previous -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPagePCS()"
                                [ngClass]="{'disable_icon':getCurrentPagePCS()== true,'enable_icon':getCurrentPagePCS()!= true}">
                                keyboard_arrow_left</mat-icon>

                            <p class="total_row_text">Total Row {{PCS_rowCount}}</p>

                            <!-- next -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;"
                                [ngClass]="{'disable_icon':isLastPagePCS()== true,'enable_icon':isLastPagePCS()!= true}"
                                (click)="goToNexpagePCS()">keyboard_arrow_right
                            </mat-icon>

                            <!-- last -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;"
                                [ngClass]="{'disable_icon':isLastPagePCS()== true,'enable_icon':isLastPagePCS()!= true}"
                                (click)="goToLastPagePCS()">last_page
                            </mat-icon>
                        </div>
                    </div>
                </div>

                <div class="col-6" style="padding:0 1.2% 0 0.8%">
                    <label class="gridcaption">LLT & Contingency Master Table</label>
                    <ag-grid-angular #ContLLTGrid style="width:100%;height: 375px;" id="LIOS-GRID" [theme]="'legacy'"
                        class="ag-theme-balham" (gridReady)="LLT_onGridReady($event);" (window:resize)="LLT_sizeToFit()"
                        [animateRows]="true" [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true"
                        [columnDefs]="LLT_columnDefs" [rowData]="LLT_displayRowData"  
                        [context]="LLT_context" [pagination]="true" [paginationPageSize]="LLT_rowCount" [icons]="icons"
                        [gridOptions]="gridOptions">
                    </ag-grid-angular>
                    <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                        <div class="w-25 col-4 ">
                            <div>
                                <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                                <select class="page-drpdwn" (change)="onLLTPageSizeChanged($event)">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="ALL" selected>ALL</option>
                                </select>
                            </div>
                        </div>

                        <div style="display: flex;" class="pagination_text col-4 offset-2">

                            <!-- first -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
                                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                                first_page</mat-icon>

                            <!-- previous -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPage()"
                                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                                keyboard_arrow_left</mat-icon>

                            <p class="total_row_text">Total Row {{LLT_rowCount}}</p>

                            <!-- next -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;"
                                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                                (click)="goToNexpage()">keyboard_arrow_right
                            </mat-icon>

                            <!-- last -->
                            <mat-icon style="cursor: pointer; margin-top: -4px;"
                                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                                (click)="goToLastPage()">last_page
                            </mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>